import { jsx } from 'react/jsx-runtime';
import { createContext } from 'react';

const NowFromServerContext = createContext({
  nowFromServer: 0
});
function NowFromServerContextProvider({
  nowFromServer,
  children
}) {
  return /* @__PURE__ */ jsx(NowFromServerContext.Provider, { value: { nowFromServer }, children });
}

export { NowFromServerContext, NowFromServerContextProvider };
//# sourceMappingURL=context.mjs.map
